const toPercent = decimal => `${decimal * 100}%`;

export default function objectPositionFromFocalPoint(presentation) {
  // Images without a focal point set return `asJson: {}`
  const focalPoint = presentation?.asJson?.focalPoint;

  if (!focalPoint) return 'center';

  return `${toPercent(focalPoint.x)} ${toPercent(focalPoint.y)}`;
}
